import type { Block } from './types';

/** Tiny builders to keep article files readable. */
export const h2 = (text: string): Block => ({ t: 'h2', text });
export const h3 = (text: string): Block => ({ t: 'h3', text });
export const p = (text: string): Block => ({ t: 'p', text });
export const ul = (items: string[]): Block => ({ t: 'ul', items });
export const ol = (items: string[]): Block => ({ t: 'ol', items });
export const callout = (text: string): Block => ({ t: 'callout', text });
export const code = (codeText: string, lang?: string): Block => ({ t: 'code', code: codeText, lang });
export const table = (head: string[], rows: string[][]): Block => ({ t: 'table', head, rows });
